/* Ocarya · carrito propio en el cajón de Shrine (27/10/2026).
   - "Mejorar" [data-oc-mejora="2|3"]: cambia el tramo de Kaching como si el cliente lo hubiera elegido en la PDP.
     Quita la línea principal y sus regalos (mismo "id" de grupo en __kaching_bundles) y añade el tramo nuevo con
     las propiedades que pone Kaching (deal, pp, main, v, id, bar/bid, abid, ab; regalos con "gift"). v, abid y ab
     se copian de la línea que había; bar y regalos salen del JSON de los ajustes (#OcCartKaching). Si el añadir
     falla, se vuelven a poner las líneas de antes.
   - "Añadir" y encender la protección: formularios [data-oc-add] → /cart/add.js.
   - Apagar la protección y quitar la protección huérfana: /cart/change.js con quantity 0.
   - Protección automática: una vez por visita (sessionStorage) y nunca si el cliente la apagó.
   - Vigilancia: cualquier petición al carrito (nuestra, del tema o de una app como Kaching, por fetch o XHR) deja
     el cajón pendiente de revisar; cuando se calman (y al abrir el cajón) se compara con /cart.js y, si las líneas no
     cuadran, se repinta. Sin esto, un cambio de Kaching después del repintado dejaba filas de más y el tema mandaba
     una línea que ya no existe ("El parámetro line no es válido", Valen 27/10/2026).
     En la misma revisión se quitan los regalos de Kaching que se quedan sin su kit (si no, se cobran enteros).
   Todo pide las secciones del cajón y repinta como renderContents() del tema, sin abrirlo.
   Delegación en document: sigue funcionando después de cada repintado. El JS del tema (shrine.null.js) no se toca.
   - Medición (29/10/2026): deja en el pedido qué hizo el cliente, oculto para él (todo empieza por "_").
     · En la línea, la propiedad _oc dice de dónde viene: carrito (oferta del cajón), mejora (tramo cambiado desde el
       cajón), auto o mano (protección puesta sola o por el cliente). Viaja en la misma petición que la añade.
     · En el carrito (atributos → pedido): _oc_vio (ofertas que vio con el cajón abierto), _oc_hizo (las que cogió),
       _oc_prot (auto, mano, quitada), _oc_quito (lo que quitó con la papelera), _oc_ficha (plantillas desde las que
       añadió), _oc_cajon (veces que se abrió), _oc_mejora_extra (céntimos que subió el total con "Mejorar", en la
       moneda del carrito), _oc_disp (movil/escritorio) y _oc_med (versión).
       Se escriben con el carrito en calma (nunca a la vez que otra petición: se perdería una de las dos), siempre
       la unión con lo que ya tenía el carrito, y al pagar van dentro del formulario del cajón. Sin interacción no se
       escribe nada.
     Shopify Flow convierte todo esto en tags del pedido. */
(() => {
  if (window.ocCartReady) return;
  window.ocCartReady = true;

  const OFF = 'oc-proteccion-off';
  const AUTO = 'oc-proteccion-auto';
  const store = {
    get: (k) => { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: (k, v) => { try { sessionStorage.setItem(k, v); } catch (e) { /* sin almacenamiento: se comporta como visita nueva */ } },
  };

  const drawer = () => document.querySelector('cart-drawer');
  const root = () => (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const url = (path) => `${root()}${path}`;
  let pending = 0; // mutaciones nuestras en vuelo: mientras tanto no se lanza la protección automática

  function kaching() {
    try { return JSON.parse(document.getElementById('OcCartKaching')?.textContent || '{}'); } catch (e) { return {}; }
  }

  function sections() {
    const d = drawer();
    return d && typeof d.getSectionsToRender === 'function' ? d.getSectionsToRender().map((s) => s.section || s.id) : [];
  }

  async function post(path, body) {
    const response = await fetch(url(path), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ ...body, sections: sections(), sections_url: window.location.pathname }),
    });
    const state = await response.json();
    if (!response.ok || state.status) throw new Error(state.description || state.message || `HTTP ${response.status}`);
    return state;
  }

  // como renderContents del tema pero sin abrir el cajón (la protección automática puede ir con el cajón cerrado)
  function paint(state) {
    const d = drawer();
    if (!d || !state || !state.sections) return;
    d.getSectionsToRender().forEach((section) => {
      const html = state.sections[section.section || section.id];
      const el = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      if (html && el) el.innerHTML = d.getSectionInnerHTML(html, section.selector);
    });
    if (typeof state.item_count === 'number') d.classList.toggle('is-empty', state.item_count === 0);
    else d.classList.remove('is-empty');
  }

  function busy(el, on) {
    if (!el) return;
    el.disabled = on;
    if (on) el.setAttribute('aria-busy', 'true'); else el.removeAttribute('aria-busy');
  }

  const kb = (item) => {
    try { return JSON.parse((item.properties || {}).__kaching_bundles || 'null'); } catch (e) { return null; }
  };

  // --- Medición: atributos del carrito que acaban en el pedido ---
  // Shopify guarda el carrito entero en cada escritura: dos escrituras a la vez y gana la última (probado 29/10: la
  // papelera del tema y un envío de atributos a la vez → el producto no se quitaba). Por eso los atributos solo se
  // escriben con el carrito en calma, y una petición al carrito que llegue mientras se escriben espera a que acabe.
  const med = (() => {
    const LISTAS = ['_oc_vio', '_oc_hizo', '_oc_prot', '_oc_quito', '_oc_ficha'];
    // contadores: veces que se abrió el cajón y céntimos que subió el total con "Mejorar" (moneda del carrito)
    const CONTADORES = ['_oc_cajon', '_oc_mejora_extra'];
    const CALMA = 1500;    // ms sin peticiones al carrito antes de escribir
    const local = {};      // lo que ha pasado en esta página: listas sin repetir, en orden
    const suma = {};       // lo sumado en esta página a cada contador
    const base = {};       // cada contador al cargar la página
    let servidor = null;   // atributos del carrito en el último /cart.js (null hasta la primera lectura)
    let sucio = false;
    let timer = 0;
    let enVuelo = 0;       // peticiones al carrito en vuelo (nuestras, del tema o de apps)
    let ultima = 0;        // cuándo acabó la última
    let escribiendo = null; // promesa de la escritura de atributos en vuelo
    const lista = (v) => String(v || '').split(',').filter(Boolean);

    function valores() {
      const out = { _oc_med: '1' };
      LISTAS.forEach((k) => {
        const todo = lista(servidor[k]);
        (local[k] || []).forEach((v) => { if (!todo.includes(v)) todo.push(v); });
        if (todo.length) out[k] = todo.join(',').slice(0, 250);
      });
      CONTADORES.forEach((k) => { if (suma[k]) out[k] = String(base[k] + suma[k]); });
      out._oc_disp = servidor._oc_disp || (window.matchMedia('(max-width: 749px)').matches ? 'movil' : 'escritorio');
      return out;
    }

    function enviar() {
      clearTimeout(timer);
      if (!sucio || !servidor || escribiendo) return; // sin la primera lectura no se manda: se pisaría lo que ya hay
      const espera = enVuelo ? CALMA : ultima + CALMA - Date.now();
      if (espera > 0) { timer = setTimeout(enviar, espera); return; }
      sucio = false;
      // ocFetchOriginal: no pasa por nuestra vigilancia (no repinta ni cuenta como petición del cliente)
      escribiendo = window.ocFetchOriginal(url('cart/update.js'), {
        method: 'POST',
        keepalive: true,
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: valores() }),
      })
        .then((r) => r.json())
        .then((cart) => { if (cart && cart.attributes) servidor = cart.attributes; })
        .catch(() => { sucio = true; })
        .finally(() => {
          escribiendo = null;
          ultima = Date.now();
          if (sucio) programar();
        });
    }
    function programar() {
      sucio = true;
      clearTimeout(timer);
      timer = setTimeout(enviar, CALMA);
    }

    return {
      leer(cart) {
        servidor = cart.attributes || {};
        CONTADORES.forEach((k) => { if (!(k in base)) base[k] = Number(servidor[k]) || 0; });
        // si algo no llegó (p. ej. lo pisó otra escritura), se vuelve a mandar; sin nada que apuntar, nada se escribe
        if (!Object.keys(suma).length && !Object.keys(local).length) return;
        const v = valores();
        if (sucio || Object.keys(v).some((k) => String(servidor[k] ?? '') !== v[k])) programar();
      },
      // vigilancia: cada petición al carrito que no es nuestra escritura
      empieza() { enVuelo += 1; },
      acaba() { enVuelo = Math.max(0, enVuelo - 1); ultima = Date.now(); },
      escribiendo: () => escribiendo,
      // al pagar: los atributos van en el mismo formulario que sale a /cart, sin otra petición
      alPagar(form) {
        if (!servidor || !form) return;
        form.querySelectorAll('input[data-oc-med]').forEach((i) => i.remove());
        Object.entries(valores()).forEach(([k, v]) => {
          const i = document.createElement('input');
          Object.assign(i, { type: 'hidden', name: `attributes[${k}]`, value: v });
          i.dataset.ocMed = '';
          form.appendChild(i);
        });
      },
      apuntar(clave, valor) {
        if (!valor) return;
        local[clave] = local[clave] || [];
        if (local[clave].includes(valor)) return;
        local[clave].push(valor);
        if (servidor && lista(servidor[clave]).includes(valor)) return;
        programar();
      },
      sumar(clave, n) {
        if (!n) return;
        suma[clave] = (suma[clave] || 0) + n;
        programar();
      },
    };
  })();

  function plantilla() {
    try { return JSON.parse(document.getElementById('OcCartPagina')?.textContent || '""'); } catch (e) { return ''; }
  }
  // ofertas a la vista con el cajón abierto
  function vistas() {
    const d = drawer();
    if (!d || !d.classList.contains('active')) return;
    d.querySelectorAll('[data-oc-oferta]').forEach((el) => med.apuntar('_oc_vio', el.dataset.ocOferta));
  }
  let ultimoCarrito = null;
  // "Kit Higiene Ocular · 3 Pasos" → "Kit Higiene Ocular"; sin comas, que separan la lista
  const nombreCorto = (item) => String(item.product_title || '').split(' · ')[0].replace(/,/g, ' ').replace(/[.\s]+$/, '').trim();
  const nuevoId = () => Array.from({ length: 4 }, () => 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'[Math.floor(Math.random() * 62)]).join('');

  // v, abid y ab se copian de la línea vieja solo si es del mismo deal; si viene de otro deal (otra PDP), los del nuestro
  const baseDe = (cfg, viejo) => (viejo.deal === cfg.deal ? viejo : { v: cfg.v || viejo.v });

  // propiedades como las pone Kaching (mismo orden de claves)
  function propsPrincipal(cfg, tramo, base, id) {
    const p = { deal: cfg.deal, pp: cfg.pp, main: true, v: base.v, id };
    p[tramo.clave || 'bar'] = tramo.bar;
    if (base.abid) { p.abid = base.abid; p.ab = base.ab; }
    return p;
  }
  function propsRegalo(cfg, base, id, gift) {
    const p = { id, deal: cfg.deal, v: base.v };
    if (base.abid) { p.abid = base.abid; p.ab = base.ab; }
    p.gift = gift;
    return p;
  }

  async function mejorar(btn) {
    const cfg = kaching();
    const n = String(btn.dataset.ocMejora);
    const destino = cfg.tramos && cfg.tramos[n];
    if (!destino) return;
    const variantes = Object.values(cfg.tramos).map((t) => Number(t.variant));
    busy(btn, true);
    pending += 1;
    try {
      const cart = await fetch(url('cart.js')).then((r) => r.json());
      const principal = cart.items.find((i) => variantes.includes(i.variant_id) && (kb(i) || {}).main);
      const viejo = principal ? kb(principal) : null;
      if (!principal || !viejo) throw new Error('Sin tramo de Kaching en el carrito');
      // el kit, sus regalos y las casillas de Kaching (Kit Higiene, 2.ª unidad) comparten grupo: si el grupo cambia y
      // las casillas se quedan con el viejo, Kaching las quita. Se sacan todas y las casillas vuelven con el grupo nuevo.
      const grupo = cart.items.filter((i) => i === principal || ((kb(i) || {}).id === viejo.id && !(kb(i) || {}).main));
      const casillas = grupo.filter((i) => (kb(i) || {}).checkboxUpsell);
      const base = baseDe(cfg, viejo);
      const sesion = (principal.properties || {}).__kaching_session_id;
      const id = nuevoId();
      const qty = principal.quantity;

      const principalNuevo = { __kaching_bundles: JSON.stringify(propsPrincipal(cfg, destino, base, id)) };
      if (sesion) principalNuevo.__kaching_session_id = sesion;
      principalNuevo._oc = 'mejora';
      // Shopify pone las líneas nuevas en orden inverso: el principal va al final para que salga primero
      const conCasillas = casillas.map((i) => {
        const p = { ...kb(i), id, deal: cfg.deal, v: base.v };
        if (base.abid) { p.abid = base.abid; p.ab = base.ab; } else { delete p.abid; delete p.ab; }
        return { id: i.variant_id, quantity: i.quantity, properties: { ...i.properties, __kaching_bundles: JSON.stringify(p) } };
      }).reverse();
      const items = conCasillas.concat((destino.regalos || []).map((r) => ({
        id: Number(r.variant), quantity: qty,
        properties: { __kaching_bundles: JSON.stringify(propsRegalo(cfg, base, id, r.gift)) },
      })).reverse()).concat([{ id: Number(destino.variant), quantity: qty, properties: principalNuevo }]);

      const updates = {};
      grupo.forEach((i) => { updates[i.key] = 0; });
      await post('cart/update.js', { updates });
      try {
        paint(await post('cart/add.js', { items }));
        med.apuntar('_oc_hizo', btn.closest('[data-oc-oferta]')?.dataset.ocOferta || `mejora-${n}`);
        // cuánto subió el total con la mejora (céntimos, moneda del carrito): lo que aporta cada "Mejorar"
        window.ocFetchOriginal(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json())
          .then((despues) => med.sumar('_oc_mejora_extra', despues.total_price - cart.total_price)).catch(() => {});
      } catch (e) {
        // no dejar el carrito sin producto: se vuelven a poner las líneas de antes
        const antes = grupo.map((i) => ({ id: i.variant_id, quantity: i.quantity, properties: i.properties }));
        paint(await post('cart/add.js', { items: antes }));
        throw e;
      }
    } catch (e) {
      console.error('[oc-cart] mejora', e);
    } finally {
      pending -= 1;
      if (btn.isConnected) busy(btn, false);
      schedule();
    }
  }

  async function anadir(form) {
    if (form.dataset.busy) return;
    const id = Number(form.querySelector('[name="id"]')?.value);
    const quantity = Number(form.querySelector('[name="quantity"]')?.value) || 1;
    if (!id) return;
    const control = form.querySelector('button[type="submit"], [data-oc-proteccion-sw]');
    // de dónde viene la línea: oferta del cajón o protección (puesta sola o por el cliente)
    const prot = form.matches('[data-oc-proteccion]');
    const origen = prot ? (form.dataset.ocOrigen || 'mano') : 'carrito';
    form.dataset.busy = '1';
    pending += 1;
    busy(control, true);
    try {
      paint(await post('cart/add.js', { items: [{ id, quantity, properties: { _oc: origen } }] }));
      if (prot) med.apuntar('_oc_prot', origen);
      else med.apuntar('_oc_hizo', form.dataset.ocOferta);
    } catch (e) {
      console.error('[oc-cart] añadir', e);
      const sw = form.querySelector('[data-oc-proteccion-sw]');
      if (sw) sw.checked = false;
    } finally {
      pending -= 1;
      delete form.dataset.busy;
      if (control && control.isConnected) busy(control, false);
      schedule();
    }
  }

  async function quitar(line) {
    if (!line) return false;
    pending += 1;
    try {
      paint(await post('cart/change.js', { line: Number(line), quantity: 0 }));
      return true;
    } catch (e) {
      console.error('[oc-cart] quitar', e);
      return false;
    } finally {
      pending -= 1;
      schedule();
    }
  }

  document.addEventListener('click', (event) => {
    const btn = event.target instanceof Element ? event.target.closest('[data-oc-mejora]') : null;
    if (!btn || btn.disabled) return;
    event.preventDefault();
    mejorar(btn);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target instanceof HTMLFormElement && event.target.matches('[data-oc-add]') ? event.target : null;
    if (!form) return;
    event.preventDefault();
    anadir(form);
  });

  document.addEventListener('change', (event) => {
    const sw = event.target instanceof HTMLInputElement && event.target.matches('[data-oc-proteccion-sw]') ? event.target : null;
    const form = sw && sw.closest('form[data-oc-proteccion]');
    if (!form) return;
    event.stopPropagation(); // que no llegue al onChange de cantidades del tema
    if (sw.checked) {
      store.set(OFF, '');
      anadir(form);
    } else {
      store.set(OFF, '1');
      busy(sw, true);
      quitar(form.dataset.line).then((ok) => { if (ok) med.apuntar('_oc_prot', 'quitada'); });
    }
  }, true);

  // papelera del cajón: qué producto quitó (la protección y los regalos no tienen papelera a la vista)
  document.addEventListener('click', (event) => {
    const boton = event.target instanceof Element ? event.target.closest('#CartDrawer cart-remove-button') : null;
    const key = boton && boton.closest('[data-oc-key]')?.dataset.ocKey;
    const item = key && ultimoCarrito && ultimoCarrito.items.find((i) => i.key === key);
    if (item) med.apuntar('_oc_quito', nombreCorto(item));
  }, true);

  // al ir a pagar, los atributos viajan en el formulario del cajón (CartDrawer-Form → POST /cart)
  document.addEventListener('click', (event) => {
    const boton = event.target instanceof Element ? event.target.closest('button[name="checkout"]') : null;
    if (boton) med.alPagar(boton.form);
  }, true);

  function revisar() {
    vistas();
    if (pending) return;
    // 1) si en el carrito solo queda la protección, se quita
    const huerfana = document.querySelector('[data-oc-huerfana]:not([data-done])');
    if (huerfana) {
      huerfana.setAttribute('data-done', '');
      quitar(huerfana.dataset.line);
      return;
    }
    // 2) protección automática: una vez por visita y nunca si el cliente la apagó
    const auto = document.querySelector('form[data-oc-auto]:not([data-done])');
    if (auto && !store.get(OFF) && !store.get(AUTO)) {
      auto.setAttribute('data-done', '');
      store.set(AUTO, '1');
      const sw = auto.querySelector('[data-oc-proteccion-sw]');
      if (sw) sw.checked = true;
      auto.dataset.ocOrigen = 'auto';
      anadir(auto);
    }
  }

  // el añadir de la ficha puede repintar el cajón dos veces: se espera a que se calme
  let timer = 0;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(revisar, 450);
  }
  new MutationObserver((records) => {
    for (const r of records) {
      for (const n of r.addedNodes) {
        if (n.nodeType === 1 && (n.matches('[data-oc-huerfana], [data-oc-proteccion]') || n.querySelector('[data-oc-huerfana], [data-oc-proteccion]'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
  schedule();

  // --- Vigilancia del cajón frente a /cart.js ---
  const esCarrito = (u) => /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/.test(String(u || ''));
  let syncTimer = 0;
  let syncing = false;
  function pedirSync(ms = 600) {
    clearTimeout(syncTimer);
    syncTimer = setTimeout(sincronizar, ms);
  }
  async function sincronizar() {
    if (syncing || pending) return pedirSync(400);
    syncing = true;
    try {
      const cart = await window.ocFetchOriginal(url('cart.js'), { headers: { Accept: 'application/json' } }).then((r) => r.json());
      ultimoCarrito = cart;
      med.leer(cart);
      // regalos de Kaching sin su kit (p. ej. el cliente quita el kit): fuera, si no se cobrarían a precio completo
      const grupos = new Set(cart.items.filter((i) => (kb(i) || {}).main).map((i) => kb(i).id));
      const huerfanos = cart.items.filter((i) => { const k = kb(i); return k && k.gift && !grupos.has(k.id); });
      if (huerfanos.length) {
        const updates = {};
        huerfanos.forEach((i) => { updates[i.key] = 0; });
        pending += 1;
        try { paint(await post('cart/update.js', { updates })); } finally { pending -= 1; }
        return pedirSync(300);
      }
      const enCarrito = cart.items.map((i) => i.key).join('|');
      const enCajon = [...document.querySelectorAll('#CartDrawer [data-oc-key]')].map((li) => li.dataset.ocKey).join('|');
      if (enCarrito === enCajon) return vistas();
      const ids = sections();
      const r = await window.ocFetchOriginal(`${url('')}?sections=${ids.join(',')}`, { headers: { Accept: 'application/json' } });
      paint({ sections: await r.json(), item_count: cart.item_count });
      vistas();
    } catch (e) {
      console.error('[oc-cart] sincronizar', e);
    } finally {
      syncing = false;
    }
  }
  // un añadir que no es nuestro (Kaching en la ficha, el tema) apunta la plantilla de la página desde la que se añade
  const esAnadir = (u) => /\/cart\/add(\.js|\.json)?(\?|$)/.test(String(u || ''));
  function anadidoFuera(u) {
    if (!pending && esAnadir(u)) med.apuntar('_oc_ficha', String(plantilla()).replace(/^product\./, '').replace(/,/g, ' '));
  }
  // cada petición al carrito se cuenta (la medición solo escribe en calma) y, si justo se están escribiendo los
  // atributos, espera a que acaben (si no, una de las dos escrituras se perdería)
  window.ocFetchOriginal = window.ocFetchOriginal || window.fetch.bind(window);
  window.fetch = function (input, init) {
    const u = input && input.url ? input.url : input;
    if (!esCarrito(u)) return window.ocFetchOriginal(input, init);
    anadidoFuera(u);
    med.empieza();
    const w = med.escribiendo();
    const p = w ? w.then(() => window.ocFetchOriginal(input, init)) : window.ocFetchOriginal(input, init);
    const fin = () => { med.acaba(); pedirSync(); };
    p.then(fin, fin);
    return p;
  };
  const xhrOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, u) {
    this.ocCarrito = esCarrito(u);
    if (this.ocCarrito) {
      anadidoFuera(u);
      this.addEventListener('loadend', () => { med.acaba(); pedirSync(); });
    }
    return xhrOpen.apply(this, arguments);
  };
  const xhrSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (!this.ocCarrito) return xhrSend.apply(this, arguments);
    med.empieza();
    const w = med.escribiendo();
    if (!w) return xhrSend.apply(this, arguments);
    const args = arguments;
    w.then(() => xhrSend.apply(this, args));
    return undefined;
  };
  // al abrir el cajón también se revisa (y se cuenta la apertura)
  const cd = drawer();
  let abierto = false;
  if (cd) {
    new MutationObserver(() => {
      const ahora = cd.classList.contains('active');
      if (ahora && !abierto) med.sumar('_oc_cajon', 1);
      abierto = ahora;
      if (ahora) pedirSync(50);
    }).observe(cd, { attributes: true, attributeFilter: ['class'] });
  }
  // y al cargar la página, por si el carrito llega descuadrado de otra visita
  pedirSync(800);
})();
